export enum FilterEvents {
  FileCreated = 'file-created',
  FileUploaded = 'file-uploaded',
  FileDeleted = 'file-deleted',
  FileMetadataUpdated = 'file-metadata-updated',
  JobStatusUpdated = 'job-status-updated',
  FlowFinished = 'flow-finished',
}

export enum FilterEventsParamsTypes {
  Path = 'path',
  MimeType = 'mimeType',
  Size = 'size',
  Access = 'access',
  Type = 'type',
  Status = 'status',
}

export const FILE_PARAM_TYPES = [
  FilterEventsParamsTypes.Path,
  FilterEventsParamsTypes.MimeType,
  FilterEventsParamsTypes.Size,
  FilterEventsParamsTypes.Access,
];

export const ALL_FILTER_EVENTS_PARAMS_TYPES = [
  FilterEventsParamsTypes.Path,
  FilterEventsParamsTypes.MimeType,
  FilterEventsParamsTypes.Size,
  FilterEventsParamsTypes.Access,
  FilterEventsParamsTypes.Type,
  FilterEventsParamsTypes.Status,
];

export const FILTER_EVENTS_TO_PARAMS_MAP = {
  [FilterEvents.FileCreated]: FILE_PARAM_TYPES,
  [FilterEvents.FileUploaded]: FILE_PARAM_TYPES,
  [FilterEvents.FileDeleted]: FILE_PARAM_TYPES,
  [FilterEvents.FileMetadataUpdated]: FILE_PARAM_TYPES,
  [FilterEvents.JobStatusUpdated]: [
    FilterEventsParamsTypes.Type,
    FilterEventsParamsTypes.Status,
  ],
  [FilterEvents.FlowFinished]: [],
};

export enum JobStatusUpdatedTypes {
  VideoTranscode = 'video-transcode',
  VideoPackage = 'video-package',
  PosterExtraction = 'poster-extraction',
  StoryboardExtraction = 'storyboard-extraction',
  Compress = 'compress',
  Decompress = 'decompress',
  FileImport = 'file-import',
}

export enum JobStatusUpdatedStatuses {
  Pending = 'pending',
  Working = 'working',
  Success = 'success',
  Error = 'error',
}

export interface FilterEventsParamsFormData {
  size?: string;
  path?: string;
  mimeType?: string;
  access?: string;
  type?: JobStatusUpdatedTypes;
  status?: JobStatusUpdatedStatuses;
}
